<template>
    <div class="white_container progress_bar_wrapper" :class="['step'+step]">
        <div class="progress_bar">
            <div class="progress"></div>
            <div class="steps" style="left: calc(10% - 22px)"><span class="s1">1</span></div>
            <div class="steps" style="left: calc(50% - 22px)"><span class="s2">2</span></div>
            <div class="steps" style="left: calc(90% - 22px)"><span class="s3">3</span></div>
        </div>
        <div class="text_progress_wrapp">
            <span class="text_step s1">{{$t("lesson.LBL_TRIAL_LESSON_STAGE")}}</span>
            <span class="text_step s2">{{$t("lesson.LBL_CONFIRM_CONTACT_DATA")}}</span>
            <span class="text_step s3">{{$t("lesson.LBL_TRIAL_STAGE")}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TrialProgressBar",
        props: {
            step: {
                type: Number,
                default: 1
            },
        },
    }
</script>

<style lang="scss"  scoped>
    .progress_bar_wrapper {
        padding: 2.3rem 3.3rem;
        margin-bottom: 2.3rem;

        .progress_bar {
        width: 100%;
        height: 24px;
        background: #F0F3F8;
        border-radius: 100px;
        position: relative;

        .progress {
            width: 0;
            height: 24px;
            background: #05C46B;
            border-radius: 100px;
        }

        .steps {
            width: 20px;
            height: 20px;
            background: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 100px;
            top: 2px;
            position: absolute;

            span {
            font-family: FuturaPT;
            font-size: 12px;
            color: rgba(11, 16, 34, 0.3);
            }
        }
        }

        .text_progress_wrapp {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        padding-right: 42px;

        span {
            font-family: FuturaPT;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: 0.5px;
            color: #0B1022;
        }
        }

        &.step1 {
            .progress {
                width: 10%;
            }

            span.s1 {
                color: #05C46B !important;
            }
        }

        &.step2 {
            .progress {
                width: 50%;
            }

            span.s2, span.s1 {
                color: #05C46B !important;
            }
        }

        &.step3 {
            .progress {
                width: 90%;
            }

            span.s2, span.s1, span.s3 {
                color: #05C46B !important;
            }
        }

        &.step4 {
            .progress {
                width: 100%;
            }

            span.s2, span.s1, span.s3, span.s4 {
                color: #05C46B !important;
            }
        }
        &.step5 {
            .progress {
                width: 100%;
            }

            span.s2, span.s1, span.s3, span.s4 {
                color: #05C46B !important;
            }
        }
    }
</style>